export const toQueryString = (obj: { [key: string]: any }) =>
  Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');
